import type { Sx } from '@mantine/core';

type SxType = Sx | (Sx | undefined)[];

export function getSx<T extends SxType>(sx: T) {
  if (!sx) {
    return [];
  }

  if (Array.isArray(sx)) {
    return sx;
  }

  return [sx];
}
